import { Container, Grid } from '@mui/material';
import ArticleHeaderCompo from './ArticleHeaderCompo';
import MKTypography from 'components/MKTypography';
import TransparentBlogCard from 'examples/Cards/BlogCards/TransparentBlogCard';
import slug from 'slug';
import MKBox from 'components/MKBox';
import data from 'csdd_data/newsAndInsights';

const ArticleCompo = ({ article }) => {
  return (
    <>
      <ArticleHeaderCompo article={article} />
      <MKBox sx={{ mx: { xs: 2, md: 40 } }}>{article.body}</MKBox>
      <Container sx={{ textAlign: 'center' }}>
        <MKTypography textGradient fontWeight='medium' variant='h3' my={5}>
          You May Also Like
        </MKTypography>
      </Container>
      <Container>
        <Grid container spacing={3}>
          {data.map((article) => {
            return (
              <Grid item xs={12} sm={6} lg={4} key={article.route}>
                <TransparentBlogCard
                  image={article.headerImage}
                  title={article.title}
                  description={article.description}
                  action={{
                    type: 'internal',
                    route: `/news/${slug(article.title)}`,
                    color: 'error',
                    label: 'read more',
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </>
  );
};
export default ArticleCompo;
